import React, { useEffect, useState } from 'react';

import logo from './logo.svg';
import './App.css';
import Nav from './Nav';
import Footer from './Footer';
import Navi from './components/Navi';
import MenuItem from './components/MenuItem';
import foodStock from './components/MenuItem';
import MenuItemsContainer from './components/MenuItemsContainer';
import ItemCardContainer from './components/ItemCardContainer';
import Banner from './Banner';

function App() {
  
  const foodItems = [
    {
      imageSrc: "https://images.fineartamerica.com/images/artworkimages/mediumlarge/2/sandwich-and-fries-foodad--multi-bits.jpg",
      title: "Chickenbake and American Fries",
      description: "Dripped with relish and mayo-sweet deluxe sauce. Work on the alcohol-fuelled engine.",
      price: "35.99",
      isPopular: true
    },
    // Add more food items here...
  ];

  return (
    
    <div className="App">
      <Navi />
      <ItemCardContainer />
      <MenuItemsContainer items={foodStock} />

      <Banner 
        bannerIntro="Introducing"
        bannerHeading='Family Bites'
        bannerContent="You've been catering to your family your entire life, now it's time for you to share those great recipes with them so they can cater to you."
        bannerButton="Join Today!"
      />

      <MenuItemsContainer items={foodStock} />

      <Banner 
        bannerIntro="Start Now"
        bannerHeading='Your Moments'
        bannerContent="Eat together and stay together.."
        bannerButton="Open Family Recipes"
      />

      <MenuItemsContainer items={foodStock} />

      <Banner 
        bannerIntro=""
        bannerHeading='Share From Home'
        bannerContent="Give the one's you love a reminder that they are always loved, not matter where they are."
        bannerButton="Love Bite"
      />

      <Footer />
    </div>

  );
}

export default App;
